"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _hooks = require("../../hooks");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  children: null,
  gap: 0,
  datasets: {},
  className: '',
  as: 'div'
};
function Column(props) {
  const {
    as,
    children,
    align,
    gap,
    flex,
    styles,
    className,
    itemProp,
    itemScope,
    itemType,
    datasets,
    forwardedRef,
    onClick
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const dataAttributes = (0, _hooks.useDataset)(datasets);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    ref: forwardedRef,
    as: as,
    align: align,
    gap: gap,
    flex: flex,
    onClick: onClick,
    className: className,
    itemProp: itemProp,
    itemScope: itemScope,
    itemType: itemType,
    styles: styles
  }, dataAttributes), children);
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), _ref => {
  let {
    gap
  } = _ref;
  return gap ? "gap: ".concat(gap, "px;") : '';
}, _ref2 => {
  let {
    flex
  } = _ref2;
  return flex ? "flex: ".concat(flex, ";") : '';
}, _ref3 => {
  let {
    align
  } = _ref3;
  let styles = '';
  if (align === 'top') styles += 'justify-content: flex-start;';
  if (align === 'center') styles += 'justify-content: center;';
  if (align === 'bottom') styles += 'justify-content: flex-end;';
  if (align === 'space-between') styles += 'justify-content: space-between;';
  if (_styled.default.length === 0) styles += 'flex: 1;';
  return styles;
}, _ref4 => {
  let {
    styles
  } = _ref4;
  return styles;
});
var _default = exports.default = Column;